import { Box, Text } from '@chakra-ui/react'
import { FC } from 'react'
import Navbar, { NavbarProps } from '../components/Navbar'

interface Prop {
  navbar: NavbarProps
  children?: React.ReactNode
}

export const MainLayout: FC<Prop> = ({ navbar, children }) => {
  return (
    <Box>
      {/* <Navbar {...navbar} /> */}
      {children}
    </Box>
  )
}

export const Maintenance: FC = () => {
  return (
    <MainLayout
      navbar={{
        colorTheme: 'dark',
        showWallet: false,
        bgTransparent: true,
      }}
    >
      <Box
        width='100vw'
        height={'100vh'}
        background={'linear-gradient(to bottom, #000000 0%, #30424D 250%)'}
        display='flex'
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Text color='white'>Rescue missions are currently experiencing an update. We should be back at 8PM UTC today.</Text>
      </Box>
    </MainLayout>
  )
}
